import { render, staticRenderFns } from "./PriceBlock.vue?vue&type=template&id=e0260f4e"
import script from "./PriceBlock.vue?vue&type=script&lang=js"
export * from "./PriceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports